import styled from 'styled-components';
import Sticky from 'react-sticky-fill';

const AnimatedSticky = styled(Sticky)`
  transition: top 200ms linear;
`;

export default AnimatedSticky;
